import { render, staticRenderFns } from "./AddAlarmPage.vue?vue&type=template&id=66823cf0&scoped=true"
import script from "./AddAlarmPage.vue?vue&type=script&lang=js"
export * from "./AddAlarmPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66823cf0",
  null
  
)

export default component.exports